import axios from '@/axios'
// Maintainers

export async function listMaintainers (code) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/maintainers?institution_code=' + code)
  return response.data.data
}

export async function getMaintainer (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/maintainers/' + id)
  return response.data.data
}

export async function saveMaintainer (data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/maintainers', data)
  return response.data
}

export async function updateMaintainer (id, data) {
  await axios.put(import.meta.env.VITE_API_URL + '/v2/intranet/maintainers/' + id, data)
}

export async function generatePassword (id) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/users/' + id + '/generate-password')
  return response.data.data
}

export async function deleteMaintainer (id) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/maintainers/' + id)
  return response.data.data
}

export default {
  listMaintainers,
  getMaintainer,
  saveMaintainer,
  updateMaintainer,
  generatePassword,
  deleteMaintainer
}
